import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { z } from "zod";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { reduceRelatedReviews } from "./utils";
import { traceFunction, tagError, getTraceId, setTag } from "@core/datadog-server";
import { storySchema } from "./utils/zod/car-review-v2-schemas";
import { zodErrorSerialiser } from "./utils/zod/utils";
import { Env, readFromEnv } from "@cinch-nx/environments";
var instrumentedGetStoryBySlug = traceFunction("getStoryBySlug", getStoryBySlug);
var requiredParams = z.object({
    make: z.string(),
    model: z.string(),
    slug: z.string()
});
export function getStaticProps(_) {
    return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
    _getStaticProps = _async_to_generator(function(param) {
        var _preview, preview, params, ddMeta, ref, make, model, slug, isInsideStoryblok, storyArgs, story, parsedResults, zodErrors, relatedReviews, _relatedReviews, response, vehicleListings, vehiclesInStock, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _preview = param.preview, preview = _preview === void 0 ? false : _preview, params = param.params;
                    setTag("request.params", params);
                    ddMeta = {
                        traceId: getTraceId(),
                        traceTime: Date.now()
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    ref = requiredParams.parse(params), make = ref.make, model = ref.model, slug = ref.slug;
                    isInsideStoryblok = preview;
                    storyArgs = {
                        version: isInsideStoryblok ? "draft" : "published",
                        resolve_relations: "CarReviewTemplateV2.relatedReviews",
                        cv: Date.now()
                    };
                    return [
                        4,
                        instrumentedGetStoryBySlug("car-reviews-v2/".concat(make, "/").concat(model, "/").concat(slug), storyArgs)
                    ];
                case 2:
                    story = _state.sent();
                    parsedResults = storySchema.safeParse(story);
                    zodErrors = [];
                    if (parsedResults.success === false) {
                        zodErrors = zodErrorSerialiser(parsedResults.error);
                    }
                    relatedReviews = [];
                    if (story === null || story === void 0 ? void 0 : story.content.relatedReviews) {
                        ;
                        (_relatedReviews = relatedReviews).push.apply(_relatedReviews, _to_consumable_array(reduceRelatedReviews(story.content.relatedReviews)));
                    }
                    return [
                        4,
                        fetch("".concat(readFromEnv(Env.SearchServiceUrl), "/vehicles?make=").concat(story.content.make, "&model=").concat(story.content.model))
                    ];
                case 3:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new Error("Failed to fetch vehicles: ".concat(response.statusText));
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 4:
                    vehicleListings = _state.sent().vehicleListings;
                    vehiclesInStock = vehicleListings.some(function(vehicle) {
                        var ref;
                        return vehicle.make.toLowerCase() === story.content.make.toLowerCase() && ((ref = vehicle.model) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === story.content.model.toLowerCase();
                    });
                    setTag("response.statusCode", 200);
                    return [
                        2,
                        {
                            props: {
                                ddMeta: ddMeta,
                                story: _object_spread_props(_object_spread({}, story), {
                                    content: _object_spread_props(_object_spread({}, story.content), {
                                        relatedReviews: relatedReviews
                                    })
                                }),
                                preview: preview,
                                validationErrors: zodErrors,
                                generatedAt: Date.now(),
                                areVehiclesInStock: vehiclesInStock
                            },
                            revalidate: 30
                        }
                    ];
                case 5:
                    error = _state.sent();
                    console.error(error);
                    if (typeof error === "string" || _instanceof(error, Error)) {
                        tagError(error);
                    }
                    if (_instanceof(error, z.ZodError)) {
                        tagError(JSON.stringify(error.flatten().fieldErrors));
                    }
                    return [
                        2,
                        {
                            notFound: true,
                            props: {
                                ddMeta: ddMeta
                            },
                            revalidate: 30
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _getStaticProps.apply(this, arguments);
}
